module.exports = __webpack_public_path__ + "img/project-11.5ae0c608.jpg";